import axios from "axios"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { myPlanPaymentHistory } from "../../../Context/api"
import { commonMessage, statusCodes } from "../../../Constants/generalConfig"
import { toast } from "react-toastify"


const UsePlanPaymentHistory = () => {
    const [listData, setListData] = useState([])
    const [count, setCount] = useState('')
    const [page, setPage] = useState(1)
    const PER_PAGE = 10
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const { id, planId } = useParams()


    useEffect(() => {
        planPaymentHistory()
    }, [])


    const planPaymentHistory = () => {
        const payload = {
            userId: id,
            planId: planId
        }
        setSpinner(true)
        axios.post(myPlanPaymentHistory(), { ...payload }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setListData(resp?.data)
                setSpinner(false)
                setCount(resp.data.totalCount);
            }
            else {
                setSpinner(false)
                setListData([])

            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    return {
        setCount,
        setPage,
        spinner,
        count,
        listData,
        page, 
        PER_PAGE
    }
}

export default UsePlanPaymentHistory